var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LeadBoardWidget',{key:(_vm.orgRef + "-lead-board"),attrs:{"orgRef":_vm.orgRef,"boardRef":_vm.boardRef,"nest-modals":"","auto-load":"","read-only":""}})}
var staticRenderFns = []

export { render, staticRenderFns }